import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { isEmpty } from "lodash-es";
import { useState } from "react";

import { useBFFProductServiceApi } from "@/api/hooks/productService.hook";

const useAccessories = () => {
    const [accessories, setAccessories] = useState<
        Array<Product<ProductFieldSet.ProductTile>> | undefined
    >();

    const [{ loading, error }, loadProducts] = useBFFProductServiceApi<
        any,
        any,
        Product<ProductFieldSet.Full>
    >(
        {
            url: `/products/:sku`,
            method: "GET"
        },
        {
            manual: true,
            useCache: false,
            autoCancel: false
        }
    );

    const loadAccessories = (sku: string) => {
        loadProducts({
            urlParams: { sku: sku },
            params: { fields: ProductFieldSet.Full }
        }).then(({ data }) => {
            const accessoriesData = data.references.accessories || [];

            if (!isEmpty(accessoriesData)) {
                setAccessories(accessoriesData);
            }
        });
    };

    return { accessories, loading, error, loadAccessories };
};

export { useAccessories };
